// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 524 ? "app" : chunkId) + "." + {"137":"8cd9b2fd9da4c8f0c69e","524":"762330cffae4239a6e0c"}[chunkId] + ".css";
};